import React, { useContext } from 'react'
import { isMobile } from 'react-device-detect'

import useStyles from './VideoOverlay.styles'
import { VideoOverlayProps } from './VideoOverlayProps'
import PlayIcon from '../../../icons/PlayIcon'
import { VideoPlayerContext } from '../VideoPlayerContext'

// Render the play-button overlay only when the video is NOT fullscreen and NOT playing.
const VideoOverlay: React.FC<VideoOverlayProps> = () => {
  const classes = useStyles()
  const { isFullscreen, isPlaying, player } = useContext(VideoPlayerContext)

  if (isFullscreen || isPlaying) {
    return null
  }

  const handleOnClick = () => {
    if (!player) return 

    if (isMobile) {
      player.requestFullscreen()
    }

    player.play()
  }

  return (
    <div className={classes.overlay}>
      {player && (
        <div
          role="button"
          tabIndex={0}
          className={classes.playContainer}
          onClick={handleOnClick}
          onKeyDown={() => {}} // Placeholder to satisfy ESLint
        >
          <div className={classes.playShade}>
            <PlayIcon className={classes.playIcon} />
          </div>
        </div>
      )}
    </div>
  )
}
export default VideoOverlay
